import * as React from 'react';
import _isEqual from 'lodash/isEqual';
import PageContext from '../../context/PageContext';
class Page extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "renderPageContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (page) => {
                const { children, className } = this.props;
                const ContentComponent = children
                    ? React.cloneElement(children, { page, ...children.props })
                    : false;
                return (React.createElement("div", { className: className }, ContentComponent));
            }
        });
        const childCount = React.Children.count(props.children);
        if (childCount > 1) {
            throw new Error('There can be only one root element as a child component.');
        }
    }
    componentDidMount() {
        this.context.changePageContext(this.props.page, this.props.pageProps, this.props.showCrumbs, this.props.mainContentClass);
    }
    componentDidUpdate(prevProps) {
        if ((prevProps.page !== this.props.page) || !_isEqual(prevProps.pageProps, this.props.pageProps)) {
            this.context.changePageContext(this.props.page, this.props.pageProps);
        }
    }
    componentWillUnmount() {
        this.context.changePageContext('DEFAULT', this.props.pageProps);
    }
    render() {
        return (React.createElement(PageContext.Consumer, null, (state) => this.renderPageContent(state.page)));
    }
}
Object.defineProperty(Page, "contextType", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: PageContext
});
Object.defineProperty(Page, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        className: ''
    }
});
export default Page;
